export const ar = {
  locale: 'ar',
  nav: {
    setup: 'مركز التحكم',
    news: 'الأخبار',
    brand: 'محاكي WC26',
    teamName: 'الفريق',
    tactics: 'التكتيك',
    fixtures: 'المباريات',
    standings: 'الترتيب',
    knockout: 'الأدوار الإقصائية',
    teamStats: 'إحصائيات الفريق',
    playerStats: 'إحصائيات اللاعبين',
  },
  landing: {
    title: 'محاكاة كأس العالم',
    subtitle: 'من المباراة الافتتاحية إلى النهائي. اختر مقعدك كمشاهد أو تولى القيادة كمدرب.',
    audienceMode: {
      title: 'وضع المشاهد',
      subtitle: 'مشاهدة كاملة للبطولة',
      desc: 'تقدم خلال كل مباراة في البطولة، وتابع الأخبار والترتيب وجداول الأدوار الإقصائية والإحصائيات.',
    },
    coachMode: {
      title: 'وضع المدرب',
      subtitle: 'تولى قيادة منتخب وطني',
      desc: 'اختر منتخباً وطنياً واجلس على مقعد المدرب. راجع تشكيلتك واضبط التشكيلة والذهنية والضغط والتوجيه الهجومي.',
    },
    completed: 'المنتهية',
    upcoming: 'القادمة',
    championRanking: 'محاكاة البطل',
    coachPickRanking: 'اختيارات المدربين',
    noCompleted: 'لا توجد مباريات منتهية بعد.',
    noUpcoming: '',
    noCoachPick: 'لا توجد اختيارات لوضع المدرب مسجلة بعد.',
    coachSetup: {
      title: 'اختر فريقك وقُدهم نحو المجد',
      back: 'رجوع',
      start: 'ابدأ رحلتي في كأس العالم',
      processing: 'جاري إنشاء الرحلة',
      hiddenTeamsOpen: "إظهار الفرق المخفية",
      hiddenTeamsClose: "إخفاء الفرق المخفية",
    },
    rosterInfo: 'المجموعة {group} · {count} لاعباً',
    simKicker: {
      audience: 'وضع المشاهد · تغطية كاملة',
      coach: 'وضع المدرب · المجموعة {group}',
    },
    simTitle: {
      audience: 'مركز التغطية الكاملة لكأس العالم',
      coach: '{flag} رحلة {name} في كأس العالم',
    },
    warning: {
      leave: 'المغادرة ستؤدي إلى فقدان بيانات المحاكاة الحالية.',
      confirm: 'المغادرة ستؤدي إلى فقدان بيانات المحاكاة. هل أنت متأكد؟',
    },
    groupLabel: 'المجموعة {id}',
    championCount: '{count} مرة',
    coachPickCount: '{count} اختيار',
  },
  common: {
    continue: 'استمرار',
    processing: 'جاري المعالجة',
    completed: 'مكتمل',
    close: 'إغلاق',
    back: 'رجوع',
    vs: 'VS',
    restart: 'بداية جديدة',
    restartConfirm: 'هل تريد بدء محاكاة جديدة؟ سيتم مسح التقدم الحالي والبيانات المحلية المحفوظة.',
    playAgain: 'العب مرة أخرى',
  },
  team: {
    tab: {
      players: 'اللاعبون',
      fixtures: 'المباريات',
      tactic: 'التكتيك',
    },
    playerTable: {
      player: 'اللاعب',
      club: 'النادي',
      status: 'الحالة',
      position: 'المركز',
      ability: 'التقييم',
      age: 'العمر',
      caps: 'دولي',
      ntGoals: 'أ دولية',
      apps: 'م',
      goals: 'أ',
      assists: 'ص',
      rating: 'معدل',
    },
    status: {
      redCard: 'بطاقة حمراء',
    },
    noTactic: 'هذا الفريق ليس لديه مباريات منتهية بعد.',
    tactic: {
      formation: 'التشكيلة',
      mentality: 'الذهنية',
      width: 'العرض',
      tempo: 'الإيقاع',
      passing: 'التمرير',
      attackRoute: 'التوجيه الهجومي',
      transition: 'الانتقال',
      pressing: 'الضغط',
      defensiveLine: 'خط الدفاع',
      possession: 'الاستحواذ',
    },
  },
  tactics: {
    formation: 'التشكيلة',
    more: 'المزيد من التشكيلات',
    roster: {
      title: 'التشكيلة',
      order: '#',
      status: 'الحالة',
      name: 'الاسم',
      position: 'المركز',
      ability: 'التقييم',
      apps: 'م',
      goals: 'أ',
      assists: 'ص',
    },
    emptySlot: 'فارغ',
    noData: 'لا توجد بيانات تكتيكية',
    benchPrefix: 'بديل',
    starterPrefix: 'أساسي',
  },
  stats: {
    team: {
      title: 'إحصائيات الفريق',
      subtitle: 'مرتب حسب الأداء التراكمي',
      noData: 'لا توجد بيانات فريق.',
      ranking: 'ترتيب الفرق',
      value: 'القيمة',
      matches: 'المباريات',
    },
    player: {
      title: 'إحصائيات اللاعبين',
      subtitle: 'ترتيب اللاعبين',
      noData: 'لا توجد بيانات لاعبين.',
      nationality: 'البلد',
      value: 'القيمة',
      apps: 'مشاركات',
    },
    playerTotals: {
      title: 'إجماليات التشكيلة',
      subtitle: 'المباريات المنتهية فقط.',
      noData: 'فريقك لم يلعب أي مباراة بعد.',
    },
    groups: {
      overall: 'عام',
      form: 'الحالة',
      discipline: 'الانضباط',
      attack: 'الهجوم',
      creative: 'الإبداع',
      goalkeeping: 'حراسة المرمى',
    },
    items: {
      avgPossession: 'متوسط الاستحواذ',
      goalsFor: 'الأهداف المسجلة',
      xg: 'xG',
      shots: 'التسديدات',
      formText: 'الحالة',
      winStreak: 'سلسلة انتصارات',
      unbeatenStreak: 'سلسلة لا هزيمة',
      winlessStreak: 'سلسلة لا فوز',
      scorelessStreak: 'سلسلة لا أهداف',
      yellowCards: 'بطاقات صفراء',
      redCards: 'بطاقات حمراء',
      fouls: 'أخطاء',
      goals: 'الأهداف',
      assists: 'التمريرات الحاسمة',
      minutesPerGoal: 'دقيقة/هدف',
      apps: 'المشاركات',
      starts: 'الأساسيون',
      averageRating: 'متوسط التقييم',
      keyPasses: 'التمريرات المفتاحية',
      passesAttempted: 'التمريرات',
      passCompletion: 'نسبة التمرير',
      saves: 'التصديات',
    },
    descriptions: {
      avgPossession: 'متوسط الاستحواذ في المباريات المنتهية',
      goalsFor: 'إجمالي الأهداف المسجلة',
      xg: 'إجمالي xG المتراكم',
      shots: 'إجمالي التسديدات',
      formText: 'الحالة الأخيرة',
      winStreak: 'سلسلة الانتصارات الحالية',
      unbeatenStreak: 'سلسلة اللاهزيمة الحالية',
      winlessStreak: 'سلسلة اللافوز الحالية',
      scorelessStreak: 'المباريات المتتالية دون أهداف',
      yellowCards: 'إجمالي البطاقات الصفراء',
      redCards: 'إجمالي البطاقات الحمراء',
      fouls: 'إجمالي الأخطاء',
      playerGoals: 'ترتيب الهدافين',
      playerAssists: 'ترتيب الصناع',
      playerXg: 'ترتيب xG اللاعبين',
      playerShots: 'ترتيب التسديدات',
      minutesPerGoal: 'الدقائق لكل هدف',
      playerApps: 'ترتيب المشاركات',
      playerStarts: 'المباريات بـ 45+ دقيقة',
      playerYellowCards: 'بطاقات صفراء للاعبين',
      playerRedCards: 'بطاقات حمراء للاعبين',
      playerAvgRating: 'متوسط التقييم',
      playerKeyPasses: 'التمريرات المفتاحية للاعبين',
      playerPasses: 'إجمالي التمريرات المحاولة',
      playerPassCompletion: 'نسبة نجاح التمرير',
      playerSaves: 'ترتيب التصديات',
    },
  },
  position: {
    gk: 'حراس المرمى',
    def: 'المدافعون',
    mid: 'لاعبو الوسط',
    fwd: 'المهاجمون',
  },
  stage: {
    'Group Stage': 'دور المجموعات',
    'Round of 32': 'دور الـ 32',
    'Round of 16': 'دور الـ 16',
    'Quarter-final': 'ربع النهائي',
    'Semi-final': 'نصف النهائي',
    'Third Place': 'المركز الثالث',
    'Final': 'النهائي',
  },
  match: {
    penaltyMarker: 'ر.ج',
    extraTimeMarker: 'و.إ',
    penalty: {
      scored: 'سجل',
      missed: 'أضاع',
    },
    status: {
      finished: 'انتهت',
      notStarted: 'لم تبدأ',
      pending: 'معلق',
    },
    viewDetail: 'عرض التفاصيل',
    modal: {
      teamData: 'إحصائيات الفريق',
      playerData: 'إحصائيات اللاعبين',
      finalResult: 'النتيجة النهائية',
      restart: 'العب مرة أخرى',
      subtitle: {
        extra: 'الوقت الأصلي {normal}، الوقت الإضافي {extra}.',
        penalty: 'الوقت الأصلي {normal}، الوقت الإضافي {extra}، ركلات الترجيح {penalty}، {winner} يتأهل.',
      },
    },
    shootout: 'ركلات الترجيح',
    extraTime: 'وقت إضافي',
    decision: {
      penalty: ' · ر.ج {home}-{away}',
      extra: ' · و.إ {home}-{away}',
    },
    news: {
      penalty: 'انتهت المباراة {normal} في الوقت الأصلي و{extra} في الوقت الإضافي؛ فاز {winner} بنتيجة {penalty} بركلات الترجيح.',
      extraTime: 'انتهت المباراة {normal} في الوقت الأصلي، مع {goals} أهداف إضافية في الوقت الإضافي. النتيجة النهائية: {final}.',
    },
    fallback: '{home} و {away} انتهت المباراة {score} في {stage}.',
    eventsFallback: 'تقررت المباراة في وسط الملعب والتفاصيل الدفاعية.',
    xg: 'xG {home}/{away}',
    possession: 'استحواذ {home}/{away}',
    shots: 'تسديدات {home}/{away}',
    best: 'الأفضل {player}',
    simulate: 'محاكاة',
    simTitle: 'نتائج المحاكاة',
    simulating: 'جارٍ المحاكاة…',
    simProgress: '10 محاكاة لهذه المباراة',
  },
  fixture: {
    title: 'المباريات',
    noDate: 'لا يوجد يوم مباراة',
    prevDay: 'يوم المباراة السابق',
    nextDay: 'يوم المباراة التالي',
  },
  knockout: {
    title: 'الأدوار الإقصائية',
    subtitle: 'الطريق من دور الـ32 إلى النهائي',
    tabs: {
      bracket: 'شجرة المواجهات',
    },
    stageNotGenerated: 'لم يتم إنشاء جدول هذه المرحلة بعد.',
    tbd: 'يحدد لاحقاً',
  },
  standings: {
    rank: 'الترتيب',
    team: 'الفريق',
    played: 'ل',
    wins: 'ف',
    draws: 'ت',
    losses: 'خ',
    goalsFor: 'له',
    goalsAgainst: 'عليه',
    goalDiff: 'ف.أ',
    points: 'نقاط',
    filter: 'تصفية',
  },
  tacticsControls: {
    mentality: {
      label: 'الذهنية',
      options: ['هجوم شامل', 'هجوم', 'إيجابي', 'متوازن', 'حذر', 'دفاعي', 'دفاع متكتل'],
    },
    width: {
      label: 'العرض',
      options: ['ضيق', 'ضيق نوعاً', 'عادي', 'واسع نوعاً', 'واسع'],
    },
    tempo: {
      label: 'الإيقاع',
      options: ['بطيء', 'بطيء نوعاً', 'عادي', 'سريع نوعاً', 'سريع'],
    },
    passing: {
      label: 'التمرير',
      options: ['كرات طويلة', 'مباشر', 'مختلط', 'قصير', 'قصير جداً'],
    },
    attackRoute: {
      label: 'التوجيه الهجومي',
      options: ['الأطراف', 'مختلط', 'الوسط'],
    },
    transition: {
      label: 'الانتقال',
      options: ['البناء من الخلف', 'البناء من الدفاع', 'مختلط', 'سريع للوسط', 'سريع للأمام'],
    },
    defensiveLine: {
      label: 'خط الدفاع',
      options: ['منخفض', 'متوسط', 'مرتفع'],
    },
    pressing: {
      label: 'الضغط',
      options: ['منخفض', 'متوسط', 'مرتفع'],
    },
    possession: {
      label: 'الاستحواذ',
      options: ['التراجع', 'استحواذ أقل', 'متوازن', 'استحواذ أكثر', 'سيطرة كاملة'],
    },
  },
  formations: {
    '4-2-3-1A': '4 مدافعين، 2 لاعبي وسط دفاعي، 2 جناح، 1 صانع لعب، 1 مهاجم',
    '4-2-3-1S': '4 مدافعين، 2 لاعبي وسط دفاعي، 1 وسط، 2 جناح، 1 مهاجم',
    '4-3-3': '4 مدافعين، 3 لاعبي وسط، 3 مهاجمين',
    '4-1-4-1': '4 مدافعين، 1 وسط دفاعي، 4 أوساط في خط واحد، 1 مهاجم',
    '4-1-2-2-1': '4 مدافعين، 1 وسط دفاعي، 2 وسط، 2 جناح، 1 مهاجم',
    '4-3-1-2M': '4 مدافعين، 3 أوساط، 1 صانع لعب، 2 مهاجم',
    '4-3-1-2D': '4 مدافعين، 3 أوساط دفاعية، 1 وسط، 2 مهاجم',
    '4-3-2-1M': '4 مدافعين، 3 أوساط، 2 صانعي لعب، 1 مهاجم',
    '4-3-2-1D': '4 مدافعين، 3 أوساط دفاعية، 2 وسط، 1 مهاجم',
    '4-3-2-1S': '4 مدافعين، 3 أوساط، 2 جناح، 1 مهاجم',
    '4-4-1-1': '4 مدافعين، 4 أوساط في خط واحد، 1 صانع لعب، 1 مهاجم',
    '4-2-2-2': '4 مدافعين، 2 وسط دفاعي، 2 جناح، 2 مهاجم',
    '4-4-2F': '4 مدافعين، 4 أوساط في خط واحد، 2 مهاجم',
    '4-4-2D': '4 مدافعين، وسط بشكل ماسي، 2 مهاجم',
    '3-3-2-2': '3 قلاب دفاع، 2 ظهير جانبي، 1 وسط دفاعي، 2 وسط، 2 مهاجم',
    '3-2-4-1': '3 قلاب دفاع، 2 وسط دفاعي، 2 على الأطراف، 2 وسط، 1 مهاجم',
    '3-2-2-2-1': '3 قلاب دفاع، 2 ظهير جانبي، 2 وسط، 2 جناح، 1 مهاجم',
    '3-2-3-2D': '3 قلاب دفاع، 2 وسط دفاعي، 2 على الأطراف، 1 وسط، 2 مهاجم',
    '3-2-3-2W': '3 قلاب دفاع، 2 ظهير جانبي، 3 أوساط، 2 مهاجم',
    '3-4-1-2': '3 قلاب دفاع، 2 ظهير جانبي، 2 وسط دفاعي، 1 صانع لعب، 2 مهاجم',
    '3-4-2-1S': '3 قلاب دفاع، 2 ظهير جانبي، 2 وسط دفاعي، 2 جناح، 1 مهاجم',
    '3-4-2-1C': '3 قلاب دفاع، 2 ظهير جانبي، 2 وسط دفاعي، 2 صانعي لعب، 1 مهاجم',
    '3-4-3F': '3 قلاب دفاع، 4 أوساط في خط واحد، 3 مهاجمين',
    '3-4-3D': '3 قلاب دفاع، وسط بشكل ماسي، 3 مهاجمين',
    '5-3-2': '5 مدافعين، 3 أوساط، 2 مهاجم',
    '5-4-1F': '5 مدافعين، 4 أوساط في خط واحد، 1 مهاجم',
    '5-4-1D': '5 مدافعين، وسط بشكل ماسي، 1 مهاجم',
    '5-2-2-1': '5 مدافعين، 2 وسط دفاعي، 2 جناح، 1 مهاجم',
  },
  news: {
    title: 'الأخبار',
    subtitle: 'تحديثات المباريات',
    titleTexts: {
      groupRecap: 'مراجعة دور المجموعات: المتأهلون والمفاجآت وترتيب المجموعات',
      knockoutRecap: 'مراجعة {stage}: المتأهلون ونقاط التحول الحاسمة',
      stagePreview: 'نظرة على {stage}: المواجهات الرئيسية والتوقعات',
      championRoad: '{flag} طريق {name} إلى المجد',
      awards: 'جوائز كأس العالم: أفضل لاعب والهداف وأفضل حارس',
      review: 'مراجعة كأس العالم: البطل والمفاجآت والنتائج الكبرى والأبطال',
      coachSummary: 'مراجعة مشوار {team}',
    },
    kicker: {
      author: 'رسالة من المؤلف',
      guide: 'دليل سريع',
      welcome: {
        coach: 'مرحباً بك في مقعد المدرب',
        audience: 'مرحباً بك في مركز البطولة',
      },
      stageRecap: 'ملخص · {stage}',
      stagePreview: 'نظرة · {stage}',
      champion: 'قصة البطل',
      awards: 'الجوائز',
      tournamentReview: 'مراجعة البطولة',
      pregame: 'قبل المباراة',
      coachSummary: 'ملخص المسيرة',
    },
    default: {
      title: 'لم تبدأ المحاكاة بعد',
      body: 'بمجرد اختيار وضع، ستبدأ الأخبار في الظهور.',
    },
    guide: {
      title: 'استمرار ستأخذك أولاً للأخبار، ثم تقدم يوم المباراة',
      body: 'يوجد زر {استمرار} في الزاوية العلوية اليسرى من الصفحة. في وضع المشاهد، تظهر الأخبار غير المقروءة أولاً. بعد قراءتها، سترى مباريات اليوم. اضغط على {استمرار} مرة أخرى لمحاكاة مباريات اليوم.',
    },
    author: {
      title: 'كلمة شكر (كبيرة) من المؤلف',
      body: 'شكراً لتحملك ذائقة مبرمج قضى ليالٍ طويلة في البرمجة. إذا أسعدتك المحاكاة، فامدح المؤلف؛ وإذا كانت النتيجة مفاجأة… فهذا جمال كرة القدم! لأي ملاحظات، تواصل معي على x.com/diysimon أو Xiaohongshu (diysimon).',
    },
    finalThanks: {
      title: 'اكتملت البطولة — شكراً للعب!',
      body: 'لقد وصلت كأس العالم 2026 إلى نهايتها. شكراً لتجربة هذه المحاكاة! تابع المؤلف (X @diysimon / Xiaohongshu diysimon) للتحديثات والملاحظات والمشاريع المستقبلية. لا تتردد في بدء محاولة جديدة وتجربة مسار مختلف!',
    },
    coachSummary: {
      intro: 'لقد انتهت رحلتك مع {team}. احتل الفريق المركز {position}.',
      record: 'خلال البطولة، حقق {team} {wins} انتصارات و{draws} تعادلات و{losses} هزائم، مسجلاً {goalsFor} هدفاً ومتلقياً {goalsAgainst}.',
      position: 'احتل {team} المركز {position}.',
      exit: 'تم إقصاؤهم في {stage} على يد {opponent}.',
      exitNone: 'أنهوا البطولة دون هزيمة في الأدوار الإقصائية.',
      topScorer: 'الهداف: {name} برصيد {goals} أهداف.',
      noScorer: 'لم يبرز أي لاعب في سباق الهدافين.',
      bestWin: 'أكبر فوز: {match}.',
      meta: '{wins}ف {draws}ت {losses}خ | {goalsFor}ل {goalsAgainst}ع | {position}',
      factRecord: 'السجل: {wins}ف {draws}ت {losses}خ',
      factGoals: 'الأهداف: {goalsFor} لـ / {goalsAgainst} ضد (فارق {diff})',
      factTopScorer: 'الهداف: {name} ({goals} أهداف)',
      factChampion: '{team} أبطال كأس العالم!',
      factFinish: 'المركز النهائي: {position}',
      positions: {
        champion: 'البطل',
        runnerUp: 'الوصيف',
        semiFinal: 'نصف النهائي',
        quarterFinal: 'ربع النهائي',
        round16: 'دور الـ16',
        round32: 'دور الـ32',
        groupStage: 'دور المجموعات',
      },
    },
    welcome: {
      coach: {
        title: '{flag} {name} تبدأ رحلتها في كأس العالم',
        body: 'لقد توليت قيادة {name}. استخدم القائمة اليسرى لعرض التشكيلة والتكتيك والمباريات والإحصائيات.',
      },
      audience: {
        title: 'تم تحميل محاكاة كأس العالم 2026 الكاملة',
        body: 'أنت تشاهد البطولة كمشاهد. النظام يتقدم مباراة بمباراة.',
      },
    },
    facts: {
      thanks: 'شكراً للعب',
      feedback: 'نرحب بملاحظاتك',
      entertainment: 'محاكاة للترفيه فقط',
      newsFirst: 'آخر الأخبار أولاً',
      fixtureBrowse: 'المباريات حسب اليوم',
      resultsGenerate: 'النتائج تولد أخباراً',
      newsUpdates: 'تحديثات الأخبار مباشرة',
      timeline: 'الجدول الزمني يظهر المباريات القادمة',
      refreshWarning: 'التحديث أو المغادرة يفقد المحاكاة',
      operation: 'كيفية اللعب',
      preMatch: 'إحاطة ما قبل المباراة',
    },
    narrative: {
      intro: {
        penalty: '{winner} تفوق {score} بركلات الترجيح بعد معركة متوترة في {stage}.',
        extraTime: '{winner} فاز {winnerScore} بعد الوقت الإضافي لينتزع فوزاً صعباً في {stage}.',
        win: [
          '{winner} سيطر على إيقاع اللعب في {stage} وحقق فوزاً {score}.',
          '{winner} تفوق على منافسه بأداء متوازن في الهجوم والدفاع، منهياً المباراة {score} في {stage}.',
          '{winner} استغل اللحظات الحاسمة في هذه المواجهة في {stage}، لينهيها {score}.',
          '{winner} لم يخفق في {stage}، محققاً فوزاً {score}.',
          'كانت منافسة {stage} متقاربة منذ البداية، لكن هدف {winner} الحاسم جعل النتيجة {score}.',
        ],
        draw: [
          'انتهت مواجهة {stage} المتوترة بالتعادل، حيث أنهى {home} و{away} المباراة {score}.',
          '{home} و{away} تبادلا الضربات في {stage}، لكن لم يتمكن أي منهما من حسمها — {score} النتيجة النهائية.',
          'انتهت {stage} دون فائز: تقاسم {home} و{away} النقاط بنتيجة {score}.',
        ],
      },
      noEvent: [
        'لم يتمكن أي من الطرفين من تحقيق الاختراق الحاسم. تميزت المباراة بمعارك وسط الملعب والتصديات في الثلث الأخير.',
        'حافظ دفاعا الفريقين على تماسكهما، تاركين فرصاً حقيقية قليلة للتسجيل.',
        'كانت اللمسة الأخيرة عنوان المباراة — الهجمات الواعدة كانت تتعطل في اللحظة الأخيرة.',
      ],
      goal: {
        extraTime: [
          '{minute}، دخل الوقت الإضافي مرحلته الحاسمة. استقبل {scorer} تمريرة {assister} و{method} مسجلاً {score}.',
          '{minute}، اغتنم {team} فرصة الوقت الإضافي حيث {method} {scorer} الكرة متجاوزاً الحارس، {team} {state}.',
          '{minute}، مع إرهاق الأرجل واتساع المساحات، {method} {scorer} بهدوء مسجلاً الكرة في الشباك، معلناً {score}.',
          '{minute}، قدم {scorer} اللحظة الحاسمة في الوقت الإضافي، {method} ليعيد {team} إلى السيطرة.',
        ],
        withAssist: [
          '{minute}، تلقى {scorer} كرة {assister} العرضية من الجهة اليمنى، {method} قبل المدافع ليصبح {score}، {team} {state}.',
          '{minute}، مرر {assister} كرة مفتاحية، انطلق {scorer} نحوها و{method} مسجلاً، {team} {state}.',
          '{minute}، نفذ {team} هجمة منسقة. مرر {assister} الكرة لـ{scorer}، الذي {method} ليصبح {score}.',
          '{minute}، استفاد {scorer} من تمريرة {assister}، {method} متجاوزاً الحارس العاجز، {team} {state}.',
          '{minute}، لعب {assister} كرة خاطفة لخط الدفاع، استلمها {scorer} بسلاسة و{method} مسجلاً — {score}.',
          '{minute}، استعاد {team} الكرة في منطقة متقدمة وتحرك بسرعة. مرر {assister} كرة عرضية لـ{scorer}، الذي {method} مسجلاً.',
          '{minute}، أرسل {assister} الكرة الثابتة إلى منطقة الجزاء. ارتقى {scorer} فوق الجميع و{method}، {team} {state}.',
          '{minute}، تلقى {scorer} كرة {assister} المرتجعة و{method} من لمسة واحدة — الهجمة أنهتها {score}.',
          '{minute}، جذب {assister} المدافعين قبل أن يمررها. وجد {scorer} المساحة و{method}، {team} {state}.',
          '{minute}، نقل {team} الكرة بصبر حتى ظهرت الفجوة. لعب {assister} التمريرة الحاسمة و{method} {scorer} مسجلاً.',
        ],
        solo: [
          '{minute}، تخلص {scorer} من مدافع على حافة المنطقة و{method}، {team} {state} — {score}.',
          '{minute}، انقض {scorer} على كرة مرتدة و{method} في المرمى الخالي.',
          '{minute}، انطلق {scorer} من وسط الملعب إلى قوس المنطقة و{method} في الشباك.',
          '{minute}، تسبب الضغط العالي لـ{team} في فوضى. كان {scorer} الأسرع في رد الفعل، {method} مسجلاً {score}.',
          '{minute}، كان {scorer} أول من رد في الزحمة، {method} من مسافة قريبة، {team} {state}.',
        ],
        methodHigh: ['حولها برأسه', 'لمسها في المرمى', 'أودعها', 'تابعها في المرمى'],
        methodLow: ['أطلقها بعيداً', 'سددها منحنية', 'قذفها بعيداً', 'أطلقها مقوسة'],
        methodMid: ['سددها بقوة', 'وضعها بهدوء', 'أطلقها', 'أنهاها', 'وجهها بدقة'],
      },
      chance: [
        '{minute}، اقترب {team} من {chanceState}. انفرد {player} بالمرمى لكن الحارس كان له بالمرصاد.',
        '{minute}، سنحت فرصة ذهبية لـ{player} داخل المنطقة لكنه أطاح بالكرة بعيداً في اللحظة الأخيرة.',
        '{minute}، شن {team} هجوماً مرتداً سريعاً، لكن تسديدة {player} مرت بمحاذاة القائم.',
        '{minute}، تلقى {player} الكرة العرضية بجري جيد لكنه لم يتمكن من توجيهها نحو المرمى.',
      ],
      redCard: [
        '{minute}، تلقى {team} ضربة قوية بعد طرد {player} بالبطاقة الحمراء، مما غيّر مسار المباراة.',
        '{minute}، طرد {player} من المباراة، مما أجبر {team} على التماسك الدفاعي لبقية اللقاء.',
        '{minute}، أظهر الحكم البطاقة الحمراء لـ{player}. اضطر {team} لتغيير مخططه على الفور.',
      ],
      flow: {
        xgGap: 'خلق {dominant} فرصاً أفضل، متقدماً {xgHome}-{xgAway} في xG و{shotsHome}-{shotsAway} في التسديدات.',
        possession: 'سيطر {controller} على الكرة بنسبة {possession}%، لكن الفعالية أمام المرمى كانت الأهم.',
        balanced: 'الفجوة في جودة الفرص كانت ضيقة ({xgHome}-{xgAway} xG)، وحُسمت المباراة في التحولات والتنفيذ النهائي.',
      },
      tactic: {
        control: [
          'تكتيكياً، فرض {controller} إيقاعه، محافظاً على الكرة بتمريرات صبورة واستحواذ بنسبة {possession}%.',
          'كانت خطة {controller} واضحة: الاحتفاظ بالكرة، الاختراق عبر الأطراف والمساحات النصفية، ومنع {away} من بناء الإيقاع.',
          'استخدم {controller} الاستحواذ المستمر لإضعاف ضغط المنافس، مُبقياً المباراة وفق شروطه.',
          'بقي {controller} متماسكاً وصبوراً في الاستحواذ، محولاً الاحتفاظ بالكرة إلى وقت أطول في الثلث الأخير.',
        ],
        direct: [
          'لم يسع {direct} وراء الاستحواذ — بل أولى إيصال الكرة إلى المنطقة بسرعة، والتسديدات الكثيرة عكست هذا النهج.',
          'في الهجوم، كان {creator} أكثر حدة في الوصول للمناطق الخطرة، وتفوقهم في التمريرات المفتاحية أبقی الدفاع تحت الضغط.',
          'نقل {direct} الكرة بهدف، متجاوزاً ازدحام وسط الملعب ومتوجهاً مباشرة نحو المرمى.',
          'أظهر {creator} تنوعاً أكبر في الثلث الأخير — العرضيات والكرات البينية ومطاردة الكرات الثانية كلها شكلت تهديدات حقيقية.',
        ],
        pressure: [
          'بذل {presser} مجهوداً هائلاً دون الكرة، مما جعل من الصعب على المنافس لعب تمريرته الأولى بنظافة.',
          'تميز الانضباط الدفاعي لـ{presser} — لاعبو الوسط تراجعوا بسرعة وأخمدوا الخطر قبل وصوله إلى المنطقة.',
          'كانت الحدة البدنية عالية. قطع {presser} خطوط الإمداد بضغط متواصل وجري استرجاعي.',
          'كان {presser} عنيفاً في استعادة الكرة بعد فقدانها — ليس دائماً بالتسديدات، لكن بإخماد الهجمات المرتدة.',
        ],
        balanced: [
          'كان كلا الطرفين حذرين في التنفيذ، حافظين على تشكيلات متماسكة وتاركين المباراة للصراعات الثنائية والكرات الثانية.',
          'لم تكن مباراة مفتوحة. لم يتخل أي طرف عن هيكله الدفاعي، معتمداً على عدد قليل من التمريرات المفتاحية للاختراق.',
          'أدار كلا الفريقين المخاطر بحذر، مما حد من الالتزام الهجومي. تشكلت المباراة بحفنة من اللحظات عالية الجودة.',
          'تكتيكياً، ألغى الطرفان بعضهما: أحدهما حاول التسريع، والآخر أغلق المساحات المركزية.',
          'قاطعت معارك وسط الملعب الإيقاع مراراً، مما أظهر أن كلا الجانبين أولى التحولات الدفاعية.',
        ],
      },
      coach: {
        late: [
          'صبر الجهاز الفني أثمر. لم يستعجل {winner} في الشوط الثاني، منتظراً إرهاق المنافس قبل توجيه الضربة الحاسمة.',
          'بقيت تبديلات وهيكل {winner} منسجمة، مما سمح بضغط متواصل في الوقت القاتل — علامة على الإدارة الجيدة.',
          'حافظ {winner} على تماسكه في حالة الجمود. الهدف المتأخر كان نتيجة طبيعية للضغط المتواصل وليس اليأس.',
          'اختار جهاز {winner} الفني مواصلة الضغط في المرحلة الأخيرة، وهو قرار منحهم اللحظة الحاسمة.',
        ],
        red: [
          'بعد البطاقة الحمراء، عدّل جهاز {redTeam} الفني التشكيلة، معتمداً على كتلة متماسكة ومرتدات سريعة للبقاء في المباراة.',
          'حاول {opponent} توسيع اللعب بفضل الأفضلية العددية، لكن الاستجابة المتماسكة لـ{redTeam} حالت دون خروج المباراة عن السيطرة.',
          'اختبر النقص العددي قدرة {redTeam} على التكيف. قللوا من التمريرات الخطرة عبر وسط الملعب وأولوا الصلابة الدفاعية.',
          'حث جهاز {opponent} الفني على تحريك الكرة بسرعة بعد الطرد، محاولاً تحويل التفوق العددي إلى أفضليات على الأطراف.',
        ],
        narrow: [
          'اتخذ جهاز {winner} الفني قراراً واقعياً — بعد التقدم، لم يطاردوا المزيد من الأهداف، بل حموا تفوقهم بتمركز متين.',
          'أولى {winner} السيطرة بعد التسجيل، مقللاً من المخاطر غير الضرورية ومبقياً المباراة تحت السيطرة.',
          'فاز {winner} دون إسراف. إدارة المخاطر من الجهاز الفني كانت في محلها، مانحة {loser} فرصاً قليلة للعودة.',
          'عكس الفوز نهج {winner} الواقعي: تأمين الدفاع أولاً، ثم ترك لاعبي الهجوم لحسم المباراة.',
        ],
        win: [
          'نفذ {winner} خطته بفعالية، محافظاً على الهيكل الهجومي حتى بعد التقدم.',
          'تمركز {winner} بذكاء في التحولات. طالب الجهاز الفني بوضوح بالضغط الفوري على الكرة بعد فقدانها.',
          'لم يكن فوز {winner} مجرد جودة فردية — فتشكيلتهم وحماية الكرات الثانية دعمت النتيجة.',
          'أظهر {winner} نضجاً في إدارة المباراة، عارفاً متى يندفع ومتى يحتفظ بالكرة.',
        ],
        draw: [
          'لم يخاطر أي من الجهازين الفنيين في التعادل. التبديلات المتأخرة والتمركز اتجه نحو تجنب الهزيمة.',
          'حاول كلا الطرفين الاختراق عبر العرض، لكن الدفاع المركزي لم يُخترق باستمرار.',
          'عكس التعادل حذر المدربين: النية الهجومية كانت موجودة، لكن لا أحد التزم بالاندفاع الكامل للأمام.',
          'عزز كلا الفريقين حماية وسط الملعب في الدقائق الأخيرة، أكثر قلقاً من هجمة مرتدة قد تحسم المباراة.',
        ],
      },
      player: {
        goals: [
          'كان {player} الاسم الأبرز، مغيراً المباراة بلمسات متعددة وحاصلاً على تقييم {rating}.',
          'غريزة {player} التهديفية حسمت المباراة — تحركاته وجدت باستمرار أصعب المساحات للدفاع.',
          'هجوم {team} أنهى {player} بلمساته، الذي أبقت تسديداته الهادئة دفاع المنافس تحت ضغط مستمر.',
          'كان {player} صانع الفارق، محولاً الفرص إلى ضغط حقيقي على لوحة النتائج.',
        ],
        attack: [
          'كان {player} مؤثراً في اللحظات الحاسمة. بعيداً عن الأهداف والتمريرات الحاسمة، لعبه الربطي أبقى {team} متحركاً للأمام.',
          'مساهمة {player} تجاوزت الأرقام — كان يظهر باستمرار حيث يحتاج الهجوم نقطة ارتكاز.',
          'اغتنم {player} فرصته في هذه المباراة، متخذاً القرارات الحاسمة التي منحت هجوم {team} نقطة تركيز.',
          'كان {player} حاسماً في الثلث الأخير — يعرف متى يمرر ومتى يسدد، منفذ موثوق لـ{team}.',
          'حركات {player} خلقت مساحات، ومشاركته المباشرة غيّرت زخم المباراة.',
        ],
        saves: [
          'كان عمل {player} في المرمى حيوياً. تصديات متعددة أبقَت {team} في المباراة.',
          'الحارس {player} يستحق ذكراً خاصاً، حيث تصدى مراراً وتكراراً لحرم المنافس.',
          'صمد {team} تحت الضغط بفضل ردود فعل {player} — تصدياته كانت عاملاً رئيسياً.',
          'لم يكن لدى {player} هامش كبير للخطأ، لكنه تعامل مع كل شيء بنظافة، حافظاً على هدوئه حتى أمام التسديدات القريبة.',
        ],
        create: [
          'كان {player} الحلقة الأهم لـ{team} في الثلث الأخير، خالقاً فرصاً للتسجيل لزملائه بتمريرات مفتاحية.',
          'رؤية {player} شكّلت أنماط هجوم {team} — وجد باستمرار ممرات التمرير في المناطق المزدحمة.',
          'احتاج {team} لمن يوصل الكرة إلى المناطق الخطرة، وملأ {player} هذا الدور بكفاءة.',
          'لم يبحث {player} عن الأهداف فقط — استخدم التمرير لوضع زملائه في أوضاع تسديد أفضل.',
        ],
        defense: [
          'غطى {player} مساحات شاسعة دفاعياً، بتدخلات واعتراضات عززت حماية وسط ملعب {team}.',
          'حد {team} من تقدم المنافس بفضل تتبّع {player} واستباقه.',
          'قيمة {player} ظهرت دون الكرة، مقطعاً هجمات المنافس قبل أن تتطور.',
          'يستحق {player} التقدير على عمله الدفاعي، منقذاً {team} من عدة مواقف خطرة حول المنطقة.',
        ],
        shots: [
          'لم يحول {player} فرصه إلى أهداف، لكن تسديداته المتواصلة أبقت دفاع المنافس على حافة الهاوية.',
          'حصة كبيرة من تهديد {team} الهجومية جاءت من {player}، الذي واصل محاولة الاختراق بالتسديدات.',
          'عدوانية {player} كانت ملحوظة — تسديدات متعددة أظهرت أنه كان يجد المساحة في الثلث الأخير باستمرار.',
          'لم يكن {player} بعيداً عن هدف — جهوده أجبرت حارس المنافس على اليقظة القصوى.',
        ],
        general: [
          'حصل {player} على أحد أعلى التقييمات، مقدماً أداء ثابتاً في كلا طرفي الملعب لـ{team}.',
          'أرقام {player} لا تروي القصة كاملة — مشاركته كانت حاسمة لإبقاء {team} في الإيقاع.',
          'أداء {player} الشامل كان الأكثر تقديراً، متخذاً القرار الصحيح في مواقف متعددة.',
          'قيمة {player} تكمن في الموثوقية — نادراً ما يهدر الكرة ودائماً متاح للعمل الدفاعي.',
        ],
      },
      impact: {
        finalWin: '{winner} فاز في النهائي ورفع كأس العالم. انتهت رحلة {loser} على بعد خطوة واحدة.',
        thirdPlace: '{winner} احتل المركز الثالث في كأس العالم، بينما حل {loser} في المركز الرابع.',
        semiFinal: '{winner} تأهل إلى النهائي بهذا الفوز، منهياً آمال {loser} في رفع الكأس.',
        quarterFinal: '{winner} بلغ نصف النهائي، على بعد فوز واحد فقط من النهائي.',
        knockoutWin: '{winner} يتقدم في الأدوار الإقصائية، بينما ودّع {loser} البطولة.',
        placementBothDark: 'تجاوز كلا الفريقين توقعات ما قبل البطولة بفارق كبير — مباراة المركز الثالث كانت بحد ذاتها قصة الطرف الأضعف.',
        placementThirdDark: '{thirdName} صعد إلى منصة التتويج من خارج قائمة أفضل 20 في توقعات ما قبل البطولة، متجاوزاً كل التوقعات.',
        placementFourthDark: '{fourthName} خسر هذه المباراة لكن الوصول إلى نصف النهائي تجاوز بالفعل توقعات ما قبل البطولة.',
        placementBothFavored: 'كلا الفريقين من بين أفضل 20 في توقعات ما قبل البطولة، والوصول إلى المربع الذهبي طابق التوقعات إلى حد كبير.',
        groupLead: '{teamName} يملك {points} نقطة من {played} مباريات في المجموعة، محتلاً المركز {rank} وفي وضع قوي للتأهل.',
        groupEliminated: '{teamName} يملك {points} نقطة فقط من {played} مباريات، محتلاً المركز {rank} وعاجزاً عن التأهل.',
        groupUpdate: 'بعد هذه المباراة، {teamName} يملك {points} نقطة، حالياً في المركز {rank} من المجموعة {group}.',
        groupQualifiers: 'المجموعة {groupId}: {names}',
        qualified: 'متأهل',
        eliminated: 'مقصي',
        favoriteStatus: '{name} {status}',
        darkHorses: '{names} أبرز الأحصنة السوداء في هذه المرحلة، متفوقة على التوقعات في النقاط أو فارق الأهداف أو المباريات الحاسمة.',
        noDarkHorses: 'عموماً، حافظ المرشحون على أرضهم — لم تشهد ترتيب المجموعات اضطراباً كبيراً.',
        unbeaten: '{names} لا تزال دون هزيمة، مظهرة اتساقاً مثيراً للإعجاب.',
        scorers: 'فردياً، {scorerLine}. {assisterLine}.{ratingLine}',
        scorerLead: 'يتصدر {name} ترتيب الهدافين بـ{goals} أهداف',
        scorerDisperse: 'سباق الهدافين لا يزال مفتوحاً',
        assisterLead: 'يتصدر {name} ترتيب الصناع بـ{assists} تمريرة حاسمة',
        assisterDisperse: 'ترتيب الصناع لا يزال تنافسياً',
        ratingHighlight: ' {name} بمتوسط {rating} — أحد أبرز لاعبي دور المجموعات.',
      },
      recap: {
        groupIntro: [
          'اكتمل دور المجموعات. تأهل 32 فريقاً وتنتقل كأس العالم إلى الأدوار الإقصائية.',
          'انتهت 72 مباراة في المجموعات. المتأهلون والمفاجآت وترتيب الهدافين تشكلت جميعها.',
          'انتهى دور المجموعات. اتساق الفرق الكبرى، وانطلاقات الفرق الأقل تصنيفاً، وسباق الهدافين حددوا هذه المرحلة.',
        ],
        knockoutIntro: 'اكتملت {stage}. بقي {count} فريقاً في سباق البطولة.',
        knockoutWinners: '{names} حجزوا تذاكرهم إلى الدور التالي.',
        knockoutTight: '{count} مباريات حُسمت بفارق هدف واحد أو ذهبت لركلات الترجيح — توتر الأدوار الإقصائية في تصاعد.',
        knockoutClear: 'نتائج هذا الدور كانت واضحة نسبياً، حيث أظهر الفائزون سيطرة أكبر.',
        knockoutBiggest: 'المباراة الأكثر غزارة في هذا الدور كانت {match}، بـ{goals} أهداف إجمالية.',
        knockoutUpset: 'المفاجأة تمثلت في فوز {winner} على {loser} — الطرف الأقل تصنيفاً قدم الأداء الأكثر كفاءة.',
        knockoutScorers: 'فردياً، {scorerLine}; {ratingLine}',
        knockoutScorerLead: 'لا يزال {name} يتصدر ترتيب الهدافين بـ{goals} أهداف',
        knockoutScorerDisperse: 'سباق الهدافين لا يزال واسعاً',
        knockoutRating: '{name} يحافظ على تقييم عالٍ، أحد أبرز نجوم الأدوار الإقصائية.',
        knockoutRatingGeneric: 'مستوى اللاعبين الرئيسيين بدأ يشكل سباق اللقب.',
        groupLines: 'المتأهلون حسب المجموعات: {lines}. {favorites}',
        groupFavorites: 'بين المرشحين، {status}.',
        groupQualifierFormat: 'المجموعة {groupId}: {names}',
        groupMeta: '{count} متأهل · {scorerInfo}',
        scorerInfo: 'الهداف {name}',
        scorerInfoUpdate: 'تم تحديث الإحصائيات',
        factQualified: '{count} متأهل',
        factDarkHorses: 'أحصنة سوداء {names}',
        factStable: 'المرشحون ثابتون',
        factTopScorer: 'الهداف {name} {goals}أ',
        factTopAssister: 'الصانع {name} {assists}ص',
        knockoutMeta: '{count} تقدم · {tight} متقارب',
        factKnockoutTight: '{count} مباريات متقاربة',
        factKnockoutClear: 'نتائج واضحة',
        factUpset: 'مفاجأة {winner}',
        factOpen: '{goals} أهداف',
      },
      preview: {
        intro: 'تحددت مواجهات {stage}. المرحلة التالية ستقلص الفرق عبر {count} مباراة.',
        keyMatch: 'مواجهات رئيسية لمشاهدتها: {matches}.',
        noKeyMatch: 'لا صدامات مباشرة بين فرق أفضل 20 في توقعات هذه المرحلة — على المرشحين تجنب الانزلاقات في مواجهات تبدو في صالحهم.',
        favorites: 'بناءً على المستوى وقوة التشكيلة، {names} مرشحون للتأهل.',
        noFavorites: 'الفجوة في هذا الدور ضيقة — المستوى واللمسة الأخيرة قد يكونان أهم من السمعة.',
        tail: [
          'في الأدوار الإقصائية، إدارة المباراة، دفاع الكرات الثابتة، ومستوى حراس المرمى تصبح حاسمة. خطأ واحد يمكن أن يعيد تشكيل شجرة البطولة بالكامل.',
          'هذه المرحلة ليست مجرد قوة هجومية. توقيت التبديلات، إدارة المخاطر، والاستعداد لركلات الترجيح ستؤثر على النتائج.',
          'على المرشحين تجنب البدايات البطيئة بينما تسعى الفرق الأقل تصنيفاً لجر المباراة إلى منطقتها الآمنة. أول 30 دقيقة ستحدد الإيقاع.',
        ],
        previewMeta: '{count} مباراة',
        factMatchup: '{count} مواجهة',
        factFocus: 'التركيز {matchup}',
        factFavorite: 'مرشح {name}',
      },
      champion: {
        road: 'اكتمل طريق {champion} إلى المجد: {count} مباراة، {wins} فوزاً، {draws} تعادلاً، {goalsFor} هدفاً مسجلاً، {goalsAgainst} مستقبلاً.',
        groupPath: 'في دور المجموعات، حجز {champion} التأهل مبكراً: {matches}.',
        knockoutPath: 'في الأدوار الإقصائية، تغلبوا على {opponents}.',
        signatureMatch: 'كانت {match} الأداء الأبرز في مشوارهم.',
        meta: '{wins}ف{draws} · {goalsFor}-{goalsAgainst}',
        drawsText: '{draws}ت',
        fact: 'البطل {champion}',
        factGoal: 'الأهداف {goalsFor}',
        factConcede: 'استقبل {goalsAgainst}',
        factSignature: 'الأبرز {match}',
        tail: [
          'السمة المميزة لهذا البطل كانت الاستقرار: السيطرة على المباريات عند التقدم وإيجاد منافذ هجومية جديدة عند التأخر أو الجمود.',
          'لم يُبنَ لقبهم على شرارة واحدة — بل جاء من صلابة دفاعية، وإنتاجية متسقة من اللاعبين الرئيسيين، وإدارة حادة.',
          'ما ميّز البطل هو أنه لم ينكسر أبداً بنتيجة سيئة واحدة، متعاملًا مع كل دور إقصائي برباطة جأش.',
        ],
      },
      awards: {
        intro: 'مع انتهاء النهائي، حُسمت الجوائز الفردية لكأس العالم. {bestPlayer}',
        bestPlayer: '{name} حصل على جائزة أفضل لاعب بفضل تقييماته العالية الثابتة وأدائه الحاسم.',
        noBestPlayer: 'سباق أفضل لاعب كان متقارباً جداً، مع نجوم متعددين قدموا مستويات عالمية.',
        topScorer: 'الحذاء الذهبي يذهب إلى {name} بـ{goals} أهداف — أنهى البطولة كأكثر الهدافين موثوقية.',
        noTopScorer: 'لم يكن لسباق الهدافين متصدر بفارق كبير، لكن فعالية المهاجمين حسمت العديد من المباريات.',
        topAssister: 'في التمريرات الحاسمة، تصدر {name} بـ{assists} — تمريراته غيّرت مباشرة نتائج مباريات عدة.',
        bestKeeper: 'جائزة أفضل حارس تذهب إلى {name}، بـ{saves} تصدياً ومتوسط {conceded} هدفاً تستقبله كل مباراة.',
        noBestKeeper: 'تركز سباق حراس المرمى بين عدد قليل من الأداء الثابت في الأدوار الإقصائية.',
        scorerFallback: 'متزعم سباق الهدافين',
        keeperFallback: 'أحد أبرز مرشحي حراسة المرمى',
        summary: '{names} شكّلوا السردية الفردية لهذه البطولة — أحدهم صنع، وآخر أنهى، وثالث أمسك الخط الخلفي.',
        noSummary: 'الأداء الفردي ارتبط بقوة بأنظمة الفرق، شكّلته الأطر التكتيكية بقدر ما شكّلته الجودة الشخصية.',
      },
      review: {
        intro: 'انتهت البطولة. {total} مباراة أنتجت {goals} هدفاً، بمتوسط {average} لكل مباراة.',
        scoring: '{highScoring} مباراة شهدت 4+ أهداف، و{btts} شهدت تسجيل كلا الفريقين. {biggest}',
        biggest: 'المباراة الأكثر غزارة كانت {match}.',
        upsetSep: 'تفوق على',
        assisterFallback: 'صنّاع متعددون',
        ratingFallback: 'لاعبون رئيسيون',
        upsets: 'ذكريات المفاجآت تشمل {upsets}.',
        noUpsets: 'في الغالب، أوفى المرشحون بتفوقهم النظري، رغم أن المباريات الإقصائية غالباً ما شكّلتها هوامش ضيقة.',
        champion: 'في النهاية، {champion} صمدت أعصابه الأطول، ليصبح السردية الأبرز للبطولة.',
        leaders: 'فردياً، لمسات {scorer} التهديفية، وإبداع {creators}، وتقييمات {ratings} العالية شكّلت العمود الإحصائي للبطولة.',
        noLeaders: 'شهدت هذه البطولة السيطرة والمفاجأة معاً — القصص الفعلية كانت أثرى من أي سطر إحصائي واحد.',
        awardsMeta: 'أفضل لاعب {name}',
        awardsMetaDefault: 'نظرة على الجوائز',
        factBestPlayer: 'أفضل لاعب {name}',
        factTopScorer: 'الهداف {name} {goals}أ',
        factBestKeeper: 'أفضل حارس {name}',
        factTopAssister: 'الصانع {name} {assists}ص',
        reviewMeta: '{count} مباراة · {goals} أهداف',
        factTotalGoals: 'إجمالي الأهداف {goals}',
        factAvgGoals: 'معدل {average} لكل مباراة',
        factHighScoring: '{count} بـ 4+ أهداف',
        factBothScored: '{count} سجل الطرفان',
      },
    },
  },
  helpers: {
    formText: { W: 'ف', D: 'ت', L: 'خ' },
    goalState: {
      equalize: 'التعادل',
      lead: 'التقدم',
      extend: 'توسيع الفارق',
      chase: 'تقليص الفارق',
    },
    chanceState: {
      extend: 'توسيع الفارق',
      break: 'كسر الجمود',
      face: 'إنقاذ الموقف',
      close: 'تقليص الفارق',
    },
    tacticSummary: 'الذهنية {mentality} · اللعب {focus} · الضغط {pressing} · الخط {line}',
    teamMate: 'زميل',
    attacker: 'مهاجم',
    defender: 'مدافع',
    advance: ' تأهل',
    groupLeader: 'متصدر المجموعة {group}: {teamName}، {points} نقطة',
    unknownPlayer: 'لاعب غير معروف',
    unsolved: 'غير متاح',
    minute: '{minute}\'{stoppage}',
    stoppageTime: '+{minute}',
  },
  rendering: {
    playerTotals: {
      headers: ['اللاعب', 'مركز', 'م', 'د', 'أ', 'ص', 'xG', 'تس', 'ع', 'تم', 'ن', 'تمم', 'تد', 'قط', 'ص', 'ح', 'تص', 'تقييم'],
    },
    matchStats: {
      shotsOnTarget: 'تسديدات على المرمى',
      passes: 'تمريرات',
      passSuccess: 'نسبة التمرير',
      keyPasses: 'تمريرات مفتاحية',
      corners: 'ركنيات',
      offsides: 'تسلل',
      fouls: 'أخطاء',
      yellowCards: 'بطاقات صفراء',
      redCards: 'بطاقات حمراء',
      saves: 'تصديات',
      tackles: 'تدخلات',
      interceptions: 'اعتراضات',
    },
    modal: {
      best: 'الأفضل',
      record: 'السجل',
      stage: 'المرحلة',
      bestPlayer: 'أفضل لاعب',
      signature: 'المباراة المميزة',
    },
    bracket: {
      pending: 'معلق',
    },
  },
  mobile: {
    landing: { intro: 'محاكي كأس العالم 2026', description: 'من مباراة الافتتاح إلى ليلة النهائي، اضغط متابعة لمشاهدة محاكاة كأس العالم 2026 كاملة.', welcome: 'مرحبًا بك في وقتك الخاص مع كأس العالم. اضغط للمشاهدة السريعة والتنبؤ بمن سيرفع الكأس. على الحاسوب تتوفر أيضًا وضعية المدرب.', hiddenStart: 'حاكِ مع الفرق المخفية', start: 'ابدأ المحاكاة', startTitle: 'ابدأ المحاكاة الآن', startSubtitle: 'فرق حقيقية ومجموعات حقيقية، ومحاكاة كاملة لكل المباريات من منظور المشاهد خلال أقل من عشر دقائق.', hiddenCheckbox: 'اجعل إيطاليا وبولندا وإندونيسيا والصين والإمارات تشارك في كأس العالم' },
    topbar: { settings: 'الإعدادات' },
    tabs: { navigation: 'تنقل الهاتف', news: 'الأخبار', fixtures: 'المباريات', standings: 'الترتيب', knockout: 'الأدوار الإقصائية', data: 'البيانات' },
    action: { continue: 'متابعة', readNews: 'قراءة الأخبار', simulateNext: 'محاكاة اليوم التالي', restart: 'إعادة البدء', completed: 'اكتملت' },
    settings: { title: 'الإعدادات', language: 'اللغة', restart: 'إعادة البدء', restartConfirm: 'هل تريد إعادة البدء ومسح المحاكاة الحالية على الهاتف؟', close: 'إغلاق الإعدادات' },
    news: { previous: 'السابق', next: 'التالي', pcMore: 'استخدم نسخة الحاسوب لمزيد من المفاجآت والميزات.', empty: 'لا توجد أخبار بعد.' },
    fixtures: { previousDay: 'اليوم السابق', nextDay: 'اليوم التالي', noMatches: 'لا توجد مباريات في هذا اليوم.' },
    standings: { groupStandings: 'ترتيب المجموعات', knockout: 'الأدوار الإقصائية', roundOf32: 'دور 32', roundOf16: 'دور 16', quarterFinal: 'ربع النهائي', semiFinal: 'نصف النهائي', thirdPlace: 'المركز الثالث', final: 'النهائي' },
    data: { goals: 'الهدافون', assists: 'التمريرات الحاسمة', pcMore: 'استخدم نسخة الحاسوب لرؤية المزيد من بيانات اللاعبين والفرق.', empty: 'لا توجد بيانات بعد.' },
    team: { squad: 'قائمة الفريق', fixtures: 'المباريات', tactic: 'الخطة', close: 'إغلاق نافذة الفريق' },
  },
    teamNames: {

    mexico: 'المكسيك', south_africa: 'جنوب أفريقيا', south_korea: 'كوريا الجنوبية',
    czechia: 'التشيك', canada: 'كندا', bosnia_herzegovina: 'البوسنة والهرسك',
    switzerland: 'سويسرا', qatar: 'قطر', brazil: 'البرازيل', morocco: 'المغرب',
    scotland: 'اسكتلندا', haiti: 'هايتي', united_states: 'الولايات المتحدة',
    australia: 'أستراليا', paraguay: 'باراغواي', turkiye: 'تركيا',
    germany: 'ألمانيا', curacao: 'كوراساو', ivory_coast: 'ساحل العاج',
    ecuador: 'الإكوادور', netherlands: 'هولندا', japan: 'اليابان',
    tunisia: 'تونس', sweden: 'السويد', belgium: 'بلجيكا', iran: 'إيران',
    egypt: 'مصر', new_zealand: 'نيوزيلندا', spain: 'إسبانيا',
    uruguay: 'الأوروغواي', saudi_arabia: 'السعودية', cape_verde: 'الرأس الأخضر',
    france: 'فرنسا', senegal: 'السنغال', norway: 'النرويج', iraq: 'العراق',
    argentina: 'الأرجنتين', austria: 'النمسا', algeria: 'الجزائر',
    jordan: 'الأردن', portugal: 'البرتغال', colombia: 'كولومبيا',
    uzbekistan: 'أوزبكستان', dr_congo: 'الكونغو الديمقراطية', england: 'إنجلترا',
    croatia: 'كرواتيا', panama: 'بنما', ghana: 'غانا',
    italy: 'إيطاليا',
    tbd: 'يحدد لاحقاً',
    china: 'الصين',

    indonesia: "إندونيسيا",
    united_arab_emirates: "الإمارات",
    poland: "بولندا",

  },
};
